import React, { Component } from "react";
import {
    Container,
    Typography,
    Hidden,
    withStyles
} from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { withRouter } from "react-router-dom";

import MockEquipamentos from "./mock_equipamentos.json";
import CustomButton from "../../shared/components/common/customButton";
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import EquipamentsPageCard from "../../shared/components/equipaments/equipamentsPageCard";
import { EquipmentModalForm } from "../../shared/components/EquipmentModalForm";

const styles = theme => ({
    container: {
        padding: "20px",
        maxWidth: "1000px",
        margin: "auto",
        backgroundColor: "white",
        lineHeight: 1.2,
    },
    title: {
        color: "#212529",
        fontWeight: 700,
        marginBottom: "20px",
        fontSize: "calc(1.325rem + .9vw)",
    },
    addIcon: {
        fontSize: "1.25rem",
        marginRight: "2px",
        marginBottom: "2px"
    },
});

class AdminEquipamentsPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            equipamentos: MockEquipamentos,
            modalAberto: false
        };
    }

    handleAddEquips = () => {
        this.setState({ modalAberto: true });
    };

    handleCloseModal = () => {
        this.setState({ modalAberto: false });
    };

    handleEquipmentSuccess = (novoEquipamento) => {
        // Adiciona o novo equipamento à lista (refetch simulado)
        this.setState(prevState => ({
            equipamentos: [...prevState.equipamentos, novoEquipamento],
            modalAberto: false
        }));
    };

    handleDetailsClick = (equipamento) => {
        const { history } = this.props;
        sessionStorage.setItem("CORE_EquipamentoSelecionado", equipamento.id);
        history.push(`/bepi/admin/equipament/details/${equipamento.id}`);
    };

    render() {
        const { classes } = this.props;
        const { equipamentos, modalAberto } = this.state;
        const { currentLanguage } = this.props
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_equipments },
        ];

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.shared.shared_breadcrumb_equipments}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Container maxWidth="md" className={classes.container}>
                    <Typography variant="h5" className={classes.title}>
                        {currentLanguage.bepiService.admin.admin_equipaments_title_my_equipments}
                    </Typography>

                    <CustomButton
                        variant="darkBlueFilled"
                        icon={<AddIcon className={classes.addIcon} />}
                        onClick={this.handleAddEquips}
                    >
                        {currentLanguage.bepiService.admin.admin_equipaments_btn_add_equipment}
                    </CustomButton>

                    {equipamentos.map((eqp) => {
                        return (
                            <React.Fragment key={eqp.id}>
                                <Hidden smDown>
                                    <EquipamentsPageCard
                                        isMobile={false}
                                        equipamento={eqp}
                                        onDetailsClick={() => this.handleDetailsClick(eqp)}
                                        currentLanguage={currentLanguage}
                                    />
                                </Hidden>
                                <Hidden mdUp>
                                    <EquipamentsPageCard
                                        isMobile={true}
                                        equipamento={eqp}
                                        onDetailsClick={() => this.handleDetailsClick(eqp)}
                                        currentLanguage={currentLanguage}
                                    />
                                </Hidden>
                            </React.Fragment>
                        );
                    })}
                </Container>

                <EquipmentModalForm
                    open={modalAberto}
                    onClose={this.handleCloseModal}
                    onSuccess={this.handleEquipmentSuccess}
                    currentLanguage={currentLanguage}
                />
            </BreadcrumbLayout>
        );
    }
}

export default withRouter(withStyles(styles)(AdminEquipamentsPage));
